import { useNavigate, useParams } from "react-router";
import {
  ObjectId,
  Stored,
  StudentOpinion,
  PopulatedVotingSession,
  PopulatePartyOpinion,
} from "../../../types";
import StatementResult from "../../../components/teacher/statement_result";
import { useEffect, useMemo, useState } from "react";
import { translate } from "../../../translations";
import { Link } from "react-router";
import { SessionProgress } from "../../../components/session/progress";
import APIclient from "../../../api-client";

export default function InspectStatement({
  votingSession,
  answers,
  toggleHiddenComment,
}: {
  votingSession: PopulatedVotingSession;
  answers: Array<Stored<StudentOpinion>>;
  toggleHiddenComment: (id: ObjectId, hidden: boolean) => void;
}) {
  const { index } = useParams();
  const indexAsNumber = Number(index);
  const navigate = useNavigate();
  const statement = votingSession.statements[indexAsNumber - 1];
  const [partyAnswers, setPartyAnswers] = useState<Array<PopulatePartyOpinion>>(
    [],
  );
  const filteredAnswers = useMemo(
    () => answers.filter((a) => a.statementId === statement?._id),
    [statement, answers],
  );

  useEffect(() => {
    APIclient.sessions
      .partyOpinions(votingSession.code, statement._id)
      .then(setPartyAnswers);
  }, [statement]);

  if (statement === undefined) {
    navigate("..");
  }

  return (
    <>
      <div className="voting-session__content">
        <Link to="../results" className="voting-session__back">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentcolor"
            className="voting-session__back-icon"
          >
            <path d="M10 18L4 12L10 6L11.4 7.45L7.85 11H20V13H7.85L11.4 16.55L10 18Z" />
          </svg>
          {translate("teacher.votingSession.statementPage.backToOverview")}
        </Link>
      </div>
      <h1 className="voting-session__title">{statement.description}</h1>

      <div className="voting-session__anchors">
        {votingSession.argumentsEnabled && (
          <a href="#studentOpinions" className="voting-session__anchor">
            {translate("teacher.votingSession.statementPage.studentAnswers")}
          </a>
        )}
        <a href="#partyOpinions" className="voting-session__anchor">
          {translate("teacher.votingSession.statementPage.partyAnswers")}
        </a>
      </div>

      <StatementResult
        argumentsEnabled={votingSession.argumentsEnabled}
        statement={statement}
        partyAnswers={partyAnswers}
        answers={filteredAnswers}
        toggleHiddenComment={toggleHiddenComment}
      />

      {/* Controls */}
      <div className="voting-session__controls">
        {indexAsNumber > 1 && (
          <button
            className="button button--secondary button--lg voting-session__control"
            onClick={() => navigate(`../results/${indexAsNumber - 1}`)}
          >
            {translate("teacher.votingSession.controls.previous")}
          </button>
        )}
        <SessionProgress
          currentStatementIndex={indexAsNumber - 1}
          statementsCount={votingSession.statements.length}
        />
        {indexAsNumber < votingSession.statements.length ? (
          <button
            className="button button--secondary button--lg voting-session__control voting-session__control--end"
            onClick={() => navigate(`../results/${indexAsNumber + 1}`)}
          >
            {translate("teacher.votingSession.controls.next")}
          </button>
        ) : (
          <button
            className="button button--secondary button--lg voting-session__control voting-session__control--end"
            onClick={() => navigate(`../results`)}
          >
            {translate("teacher.votingSession.controls.backToOverview")}
          </button>
        )}
      </div>
    </>
  );
}
